<template>
    <v-container fluid>
        <v-row justify="center" class="ma-0">
            <v-card style="border-top: solid; border-top-color: #10303D; border-top-width: 3px;">
                <v-card-title>
                    <v-row class="ma-0">
                        <span>Distribuição de Mortalidade</span>
                    </v-row>
                </v-card-title>
                <v-divider/>
                <v-card-text>
                    <v-container fluid>
                        <!-- Filtros -->
                        <v-row>
                            <mortality-distribution-filters @apply="listMortalityDistribution" @removeComparativos="removerTodosGraficos"
                                                            :listMortalityLimits.sync="listaTabelasLimiteMortalidade" />
                        </v-row>
                        <!-- <v-row v-if="dataMortalidade.length === 0 && exibeGrafico" justify="center" >
                            <v-alert border="left" color="primary" elevation="4" icon="fa-exclamation-triangle" outlined type="error">
                                Não foi possível encontrar lotes com essas características. Selecione novamente os filtros desejados.
                            </v-alert>
                        </v-row> -->
                        <v-row v-for="(dataGraph, idx) in listDataGraph" :key="idx">
                            <v-col cols="2" xl="2">
                                <v-subheader>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    depressed
                                                    icon
                                                    x-small
                                                    color="#ff5252"
                                                    @click.native="removerGrafico(idx)"
                                                    class="mr-2 card-actions__btn delete"
                                            >
                                                <v-icon x-small color="white">fas fa-trash</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Remover comparativo</span>
                                    </v-tooltip>
                                    Filtros
                                </v-subheader>
                                <div>
                                    <v-container class="py-0" v-if="exibeGrafico">
                                        <v-row align="center" justify="start">
                                            <v-col v-for="(selection) in dataGraph.listDataFilters" :key="selection.text" class="shrink" style="padding: 3px;">
                                                <v-chip>
                                                    {{ selection.text }}
                                                </v-chip>
                                            </v-col>
                                        </v-row>
                                    </v-container>
                                </div>
                            </v-col>
                            <v-col cols="10" xl="10" v-if="exibeGrafico">
                                <!-- Chart -->
                                <v-subheader>Gráfico</v-subheader>
                                <mortality-distribution-bar-graph
                                        v-if="csTipoGrafico === 'VE'"
                                        :values="dataGraph.listDataMortalidade"
                                        :categories="dataGraph.categories"
                                        :limit-data="limiteMortalidadeData"
                                />
                                <mortality-distribution-horizontal-bar-graph
                                        v-else-if="csTipoGrafico === 'HO'"
                                        :values="dataGraph.listDataMortalidade"
                                        :categories="dataGraph.categories"
                                />
                                <mortality-distribution-line-graph
                                        v-else-if="csTipoGrafico === 'LG'"
                                        :values="dataGraph.listDataMortalidade"
                                        :categories="dataGraph.categories"
                                        :limit-data="limiteMortalidadeData"
                                />
                                <mortality-distribution-heat-map
                                        v-else
                                        :values="dataGraph.listDataMortalidade"
                                        :categories="dataGraph.categories"
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
            <AppLoaderBlockCard :overlay="loading"/>
        </v-row>
    </v-container>
</template>

<script>
import {URLS} from '@/modules/MortalityDistribution/api/urls';
import MortalityDistributionFilters from '@/modules/MortalityDistribution/components/MortalityDistributionFilters';
import MortalityDistributionHorizontalBarGraph from "@/modules/MortalityDistribution/components/MortalityDistributionHorizontalBarGraph";
import MortalityDistributionBarGraph from "@/modules/MortalityDistribution/components/MortalityDistributionBarGraph";
import MortalityDistributionLineGraph from "@/modules/MortalityDistribution/components/MortalityDistributionLineGraph";
import MortalityDistributionHeatMap from "@/modules/MortalityDistribution/components/MortalityDistributionHeatMap";
import { dateLocalToIso, dateIsoToLocal } from '@/filters/utils'
import AppLoaderBlockCard from '@/components/layout/AppLoaderBlockCard.vue'

export default {
    name: 'MortalityDistribution',
    components: {MortalityDistributionHeatMap, MortalityDistributionHorizontalBarGraph, MortalityDistributionBarGraph,
        MortalityDistributionLineGraph, AppLoaderBlockCard,
        MortalityDistributionFilters},
    data: () => ({
        listDataGraph: [],
        categories: [],
        loading: false,
        exibeGrafico: false,
        csTipoGrafico: 'VE',
        mortalityLimits: [],
        csLimiteMortalidadeLista: [],
        listaTabelasLimiteMortalidade: []
    }),
    methods: {
        dateLocalToIso,
        dateIsoToLocal,
        removerTodosGraficos() {
            this.listDataGraph = []
        },
        removerGrafico(index) {
            this.listDataGraph.splice(index, 1);
        },
        async listMortalityDistribution(queryParams = null, listaUepOrigem = null, technicalManagers = null, tiposComedouro = null, tiposBebedouro = null, tiposPiso = null) {
            this.loading = true;
            this.csLimiteMortalidadeLista = [];
            this.exibeGrafico = false

            if (queryParams){
                this.csTipoGrafico = queryParams['csTipoGrafico'] || 'VE';
                delete queryParams.csTipoGrafico;

                this.csLimiteMortalidadeLista = queryParams['csLimiteMortalidadeLista'] || [];
                delete queryParams.csLimiteMortalidadeLista;
            }

            const response = await this.$axios
                .get(URLS.MORTALITY_DISTRIBUTION, {
                    params: queryParams
                })
                .finally(() => (this.loading = false));

            if (response.status === 200) {
                if (response.data.length > 0) {
                    const data = response.data[0].data;
                    if (data.series.length > 0) this.toDataMortalidade(data, queryParams, listaUepOrigem, technicalManagers, tiposComedouro, tiposBebedouro, tiposPiso);
                    else this.$store.commit('setSnack', {type: 'error', msg : 'Não foi possível encontrar lotes com essas características!'});
                }
            }
        },
        toDataMortalidade(data, filterParams, listaUepOrigem, technicalManagers, tiposComedouro, tiposBebedouro, tiposPiso) {
            let categories = data.categories;

            data.series.sort((a, b) => {
                return (
                    new Date(a.name + '-1') - new Date(b.name + '-1')
                )
            })

            let dataMortalidade = data.series.map((entry) => ({
                name: entry.name.split('-').reverse().join('/'),
                data: entry.data,
                max: Math.max(...entry.data),
            }));

            let dataFilter = []
            if (filterParams == null) {
                let itemFilter = {
                    text: 'Nenhum Filtro selecionado'
                }
                dataFilter.push(itemFilter)
            }
            else {
                for (var key in filterParams) {
                    let texto = ''
                    if (key == 'dtInicio') {
                        texto = 'Mortalidade de: ' + dateIsoToLocal(filterParams[key])
                    }
                    else if (key == 'dtFim') {
                        texto = 'Mortalidade até: ' + dateIsoToLocal(filterParams[key])
                    }
                    else if (key == 'dtInicioAlojamento') {
                        var dataArray = filterParams[key].split('-')
                        texto = 'Alojados em: ' + dataArray[1] + '/' + dataArray[0]
                    }
                    else if (key == 'dtFimAlojamento') {
                        continue
                    }
                    else if (key == 'dtInicioFechamento') {
                        var dataArray = filterParams[key].split('-')
                        texto = 'Finalizados em: ' + dataArray[1] + '/' + dataArray[0]
                    }
                    else if (key == 'dtFimFechamento') {
                        continue
                    }
                    else if (key == 'csTipoUep') {
                        texto = 'Tipo UEP: ' + this.uepTypes.find(x => x.csTipoUep === filterParams[key]).dsTipoUep
                    }
                    else if (key == 'cdUepOrigem') {
                        texto = 'Origem: ' + listaUepOrigem.find(x => x.idUnidadeExploracao == filterParams[key]).displayText
                    }
                    else if (key == 'cdResponsavelTecnico') {
                        texto = 'Extensionista: ' + technicalManagers.find(x => x.idResponsavelTecnico == filterParams[key]).nmPessoa
                    }
                    else if (key == 'sgSexo') {
                        texto = 'Gênero dos animais: ' + this.genderTypes.find(x => x.sgSexo === filterParams[key]).dsSexo
                    }
                    else if (key == 'flAberto') {
                        let value = filterParams[key] ? 'AB' : 'FE'
                        texto = 'Status do lote: ' + this.statusTypes.find(x => x.csStatus === value).dsStatus
                    }
                    else if (key == 'cdTipoComedouro') {
                        texto = 'Comedouro: ' + tiposComedouro.find(x => x.idTipoComedouro === filterParams[key]).nmTipoComedouro
                    }
                    else if (key == 'cdTipoBebedouro') {
                        texto = 'Bebedouro: ' + tiposBebedouro.find(x => x.idTipoBebedouro === filterParams[key]).nmTipoBebedouro
                    }
                    else if (key == 'cdTipoPiso') {
                        texto = 'Piso: ' + tiposPiso.find(x => x.idTipoPiso === filterParams[key]).nmTipoPiso
                    }
                    else if (key == 'nrSemana') {
                        texto = 'Semana: ' + this.weekTypes.find(x => x.nrSemana === filterParams[key]).dsSemana
                    }
                    else {
                        continue
                    }

                    let itemFilter = {
                        text: texto
                    }
                    dataFilter.push(itemFilter)
                }
            }

            if (this.csTipoGrafico != 'VE')
            {
                let newData = {
                        listDataMortalidade: dataMortalidade,
                        categories: categories,
                        listDataFilters: dataFilter
                    }
                this.listDataGraph.push(newData)
            }
            else {
                if (this.listDataGraph.length > 0) {
                    for (var idx in dataMortalidade) {
                        this.listDataGraph[0].listDataMortalidade.push(dataMortalidade[idx])
                    }
                    for (var idx in dataFilter) {
                        this.listDataGraph[0].listDataFilters.push(dataFilter[idx])
                    }
                }
                else {
                    let newData = {
                        listDataMortalidade: dataMortalidade,
                        categories: categories,
                        listDataFilters: dataFilter
                    }
                    this.listDataGraph.push(newData)
                }
            }
            this.exibeGrafico = true
        },
        listMortalityLimits() {

			this.$axios
                .get(URLS.TABELA_META_MORTALIDADE)
                .then(res => {
					if (!res.data) return;
					if (!res.data[0]) return;
					if (!res.data[0].data) return;
                    
					this.mortalityLimits = res.data[0].data;
					this.listaTabelasLimiteMortalidade = this.mortalityLimits.map(v => ({
                        nmTabela: v.nmTabela,
                        sgTipoUep: v.sgTipoUep
					}));
				})
                .catch((error) => {
                    this.$store.commit("setSnack", {type: "error", msg: error})
                })
		},
    },
    computed: {
        limiteMortalidadeData() {
            if (this.csLimiteMortalidadeLista.length === 0) return []

            let filteredData = this.mortalityLimits.filter(v => (
               this.csLimiteMortalidadeLista.find((val) => val === v.nmTabela)
            ));

            if (!filteredData) return [];
            return filteredData;
        },
        uepTypes() {
            return [
                {csTipoUep: 'CR', dsTipoUep: 'Creche'},
                {csTipoUep: 'TR', dsTipoUep: 'Terminação'},
                {csTipoUep: 'WF', dsTipoUep: 'Wean to Finish'},
                {csTipoUep: 'UP', dsTipoUep: 'UPL'}
            ];
        },
        statusTypes() {
            return [
                {csStatus: 'AB', dsStatus: 'Aberto'},
                {csStatus: 'FE', dsStatus: 'Fechado'}
            ];
        },
        genderTypes() {
            return [
                {sgSexo: 'MA', dsSexo: 'Macho'},
                {sgSexo: 'FE', dsSexo: 'Fêmea'},
                {sgSexo: 'MI', dsSexo: 'Misto'}
            ];
        },
        weekTypes() {
            return [
                {nrSemana: 1, dsSemana: 'Semana 1'},
                {nrSemana: 2, dsSemana: 'Semana 2'},
                {nrSemana: 3, dsSemana: 'Semana 3'},
                {nrSemana: 4, dsSemana: 'Semana 4'},
                {nrSemana: 5, dsSemana: 'Semana 5'},
                {nrSemana: 6, dsSemana: 'Semana 6'},
                {nrSemana: 7, dsSemana: 'Semana 7'},
                {nrSemana: 8, dsSemana: 'Semana 8'},
                {nrSemana: 9, dsSemana: 'Semana 9'},
                {nrSemana: 10, dsSemana: 'Semana 10'},
                {nrSemana: 11, dsSemana: 'Semana 11'},
                {nrSemana: 12, dsSemana: 'Semana 12'},
                {nrSemana: 13, dsSemana: 'Semana 13'},
                {nrSemana: 14, dsSemana: 'Semana 14'},
                {nrSemana: 15, dsSemana: 'Semana 15'},
                {nrSemana: 16, dsSemana: 'Semana 16'},
                {nrSemana: 17, dsSemana: 'Semana 17'},
                {nrSemana: 18, dsSemana: 'Semana 18'},
                {nrSemana: 19, dsSemana: 'Semana 19'},
                {nrSemana: 20, dsSemana: 'Semana 20'},
                {nrSemana: 21, dsSemana: 'Semana 21'}
            ];
        },
        graphTypes() {
            return [
                { csTipoGrafico: 'VE', dsTipoGrafico: 'Vertical' },
                { csTipoGrafico: 'HO', dsTipoGrafico: 'Horizontal' },
                { csTipoGrafico: 'MC', dsTipoGrafico: 'Mapa de Calor' },
                { csTipoGrafico: 'LG', dsTipoGrafico: 'Linhas' }
            ];
        }
    },
    mounted() {
        this.listMortalityLimits();
    }
};
</script>

